<template>
  <form class="dropzone">
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span v-if="$route.name == 'CadastroUsuario'" class="dropzone-title"
        >Arraste uma imagem aqui</span
      >
      <span v-else-if="$route.name == 'DocumentosEmpresa' || $route.name == 'DocumentosPessoa'" class="dropzone-title"
        >Arraste aqui um documento</span
      >
      <span v-else class="dropzone-title">Arraste uma imagem aqui</span>
      <span class="dropzone-info">Ou clique aqui para selecionar</span>
    </div>
  </form>
</template>

<script>
import Dropzone from "dropzone";
import "../../../node_modules/dropzone/dist/dropzone.css";
import lambda from "@/aws/lambda";
Dropzone.autoDiscover = false;
export default {
  name: "dropzone",
  mounted() {
    const vm = this;
    let options = {
      // The URL will be changed for each new file being processing
      url: "/",
      // Since we're going to do a `PUT` upload to S3 directly
      method: "get",
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        let _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      uploadMultiple: false,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: "",
      // Customize the wording
      dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
      dictFallbackMessage: "Navegador não suportado",
      dictFileTooBig: "O tamanho do arquivo é muito grande. Máximo 5MB",
      dictInvalidFileType: "Tipo de arquivo inválido",
      dictCancelUpload: "Cancelar",
      dictUploadCanceled: "Cancelado",
      dictRemoveFile: "Remover",
      dictMaxFilesExceeded: "Permitido envio de apenas um arquivo",
      dictResponseError: "Erro no servidor",
      // We're going to process each file manually (see `accept` below), If false call 'myDropzone.processQueue()' to send
      autoProcessQueue: false,
      // Other configuraration options
      maxFilesize: 5,
      maxFiles: 1,
      acceptedFiles: "image/*,application/pdf,.doc,.docx,.xls,.xlsx",
      addRemoveLinks: true,
      // Here we request a signed upload URL when a file being accepted
      accept(file, done) {
        lambda
          .getSignedURL(file)
          .then((url) => {
            
            file.uploadURL = url;
            done();
            // Manually process each file
            setTimeout(() => vm.dropzone.processFile(file));
          })
          .catch((err) => {
            done("Failed to get an S3 signed upload URL", err);
          });
      },
    };
    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, options);
    // Set signed upload URL for each file
    vm.dropzone.on("processing", (file) => {
      vm.dropzone.options.url = file.uploadURL;

    });

    vm.dropzone.on("removedfile", (file) => {
      vm.dropzone.options.url = "";
      this.$emit("removedfile");
      lambda.deleteGetSignedURL(
        file.uploadURL.split("?")[0].split("/").slice(-1)[0]
      );
    });

    vm.dropzone.on("success", (event) => {
      this.$emit("urlArquivo", event.uploadURL.split("?")[0]);
    });

    vm.dropzone.on("resetFiles", function () {
      if (this.files.length != 0) {
        this.files[0].previewElement.remove();
        this.files.length = 0;
      }
    });
    //vm.dropzone.on("complete", function(file) { vm.dropzone.removeFile(file); });
  },
};
</script>

<style lang="stylus">
primaryBlue = #00b8d4;

form.dropzone {
  transition: all 0.2s linear;
  border: 2px dashed #ccc;
  background-color: #fafafa;
  min-height: initial;

  &:hover {
    border-color: primaryBlue;
    background-color: white;

    .dz-message {
      .dropzone-title {
        color: primaryBlue;
      }
    }
  }

  .dz-message {
    color: #666;

    span {
      line-height: 1.8;
      font-size: 13px;
      letter-spacing: 0.4px;

      span.dropzone-title {
        display: block;
        color: #888;
        font-size: 1.25em;
      }

      span.dropzone-info {
        display: block;
        color: #a8a8a8;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/compartilhados/Dropzone.vue